import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyComponent = lazyForPaint(
	() => import(/* webpackChunkName: "async-confluence-content-v2" */ './index-v2'),
);

export const AsyncConfluenceContent = () => (
	<JSErrorBoundary id="async-confluence-content" packageName="issue-view-base">
		<LazyComponent />
	</JSErrorBoundary>
);

export default AsyncConfluenceContent;
